<template>
  <v-flex xs12 sm12>
    <v-card
      class="mx-auto"
    >
      <v-card
        dark
        flat
      >
        <v-btn
          absolute
          bottom
          color="pink"
          right
          fab
          @click="dialog = true"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-img
          src="https://cdn.vuetifyjs.com/images/cards/forest.jpg" width="100%"
          gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
        >
          <v-container fill-height>
            <v-layout align-center>
              <strong class="display-4 font-weight-regular mr-4">{{ dateToday }}</strong>
              <v-layout column justify-end>
                <div class="headline font-weight-light">{{ dateWeek }}</div>
                <div class="text-uppercase font-weight-light">{{ dateMonthYear }}</div>
              </v-layout>
            </v-layout>
          </v-container>
        </v-img>
      </v-card>
      <v-card-text class="py-0">
        <v-timeline
          align-top
          dense
          v-for="(item, i) in items"
          :key="i"
        >
          <v-timeline-item
            color="pink"
            small
          >
            <v-layout pt-3>
              <v-flex xs3>
                <strong>{{item.date}}</strong>
              </v-flex>
              <v-flex>
                <strong>{{item.doctor}}</strong>
                <pre class="caption">{{item.history}}</pre>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>

    <div class="text-xs-center">
      <v-dialog
        v-model="dialog"
        width="500"
        :fullscreen="getDevice.isMobile"
        :hide-overlay="getDevice.isMobile"
      >
        <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Dados</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="dialog = false">Sair</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card>
        <v-card-text>
          <new-record/>
        </v-card-text>

        <v-divider></v-divider>

        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </div>


  </v-flex>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'
  import NewRecord from './new'

  moment.locale('pt-br')
  export default {
    components: {
      NewRecord
    },
    computed: {
      cardSize: () => {
        if (!this.getDevice.isMobile) {
          console.log('asasaa')
          return '400'
        }
      },
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('medicalRecord', ['getListRecord', 'getAvailableAppointments']),
      ...mapGetters('app', ['getTheme', 'getDevice']),
      ...mapGetters('patient', ['getPatient'])
    },
    data () {
      return {
        cardSizeData: '',
        env: process.env,
        items: [],
        dateToday: moment().format('DD'),
        dateMonthYear: moment().format('MMMM YYYY'),
        dateWeek: moment().format('dddd'),
        dialog: false
      }
    },
    mounted () {
      this.$bus.$on('getMedicalRecord', this.loadingRecord)
      this.$bus.$on('closeModal', this.closeModal)
    },
    methods: {
      ...mapActions('medicalRecord', ['setListRecord', 'setAvailableAppointments']),
      loadingRecord (selected) {
        if (!selected) return false
        this.items = this.getListRecord
      },
      closeModal () {
        this.dialog = false
        this.setListRecord(this.getPatient.id).then(() => {
          this.items = this.getListRecord
        })
      },
      submit (e) {
        // this.setList().then(() => {
        this.items = this.getListRecord
        // })
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/patient/record/index.vue